<template>
  <div class="modal-field">
    <button class="modal-field__close-btn" @click="closeModal">
      <BaseIcon name="cross" />
    </button>
    <h1 class="modal-field__title" v-html="title"></h1>
    <FormField
      class="modal-field__form modals-container__scroll-content"
      v-model="form"
      :scope="modalData.scope"
      :forbiddenKeys="forbiddenKeys"
      :parent="modalData.parent"
      :showKeyHint="modalData.scope !== 'customobjectsgroups'"
    ></FormField>
    <div class="modal-field__buttons">
      <BaseButton title="Cancel" @click.native="closeModal"/>
      <BaseButton title="Save" @click.native="handleSubmit" theme="primary"/>
    </div>
  </div>
</template>

<script>
  import FormField from '@/components/forms/FormField'
  import { MDSModalEditFieldModel } from '@/models/modal-datasets.model'

  export default {
    components: {
      FormField
    },
    props: {
      modalData: MDSModalEditFieldModel
    },
    data () {
      return {
        title: null,
        form: null
      }
    },
    computed: {
      forbiddenKeys () {
        return this.form && this.form.key ? this.modalData.usedKeys.filter(k => k !== this.form.key) : this.usedKeys
      }
    },
    methods: {
      closeModal () {
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      async handleSubmit () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          console.warn('Invalid form')
          return
        }
        
        this.$eventBus.$emit('ModalNewField/PATCH_FIELD', { form: this.form, editedField: this.modalData.field })
        this.closeModal()
      },
      setTitle () {
        const { label } = this.modalData.field
        this.title = `Edit field ${label ? `<strong>${label}</strong>` : ''}`
      },
      initForm () {
        const { key, label, description, type, subForm } = this.modalData.field
        this.form = { key, label, description, type, subForm }
      },
      handleKeyEvent (e) {
        // Dont add ENTER listener, for now enter is reservered for textarea to make newline!!!
        // if (e.keyCode === 13) {
        //   this.handleSubmit()
        // }
      },
    },
    created () {
      this.setTitle()
      this.initForm()
    },
    mounted () {
      document.addEventListener('keydown', this.handleKeyEvent)
    },
    beforeDestroy () {
      document.removeEventListener('keydown', this.handleKeyEvent)
    }
  }
</script>

<style lang="scss" src="./modal-field.scss"></style>


// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalEditField.vue